import "Data/ServerSource";
/** @namespace Dict.Data */
NS("Dict.Data");

/**
 * Dict.Data.DynamicDicts source
 * @class
 * @extends Data.ServerSource
 */
Dict.Data.DynDicts = Class(Data.ServerSource, /** @lends Dict.Data.DynDicts.prototype */ {
    url: "Dict/Web/DynDicts/",
    fields: [
        { name: "id", title: "id" }, // int
        { name: "userid", title: "userid" }, // int
        { name: "name", title: "name" }, // string
        { name: "alias", title: "alias" }, // string
        { name: "description", title: "description" }, // string

        { name: "createddatetime", title: "createddatetime" }, // string
        { name: "modifieddatetime", title: "modifieddatetime" }, // string
        { name: "creator", title: "creator" }, // json
        { name: "modifier", title: "modifier" }, // json
    ],
});
